import { createSelector } from 'reselect'

export const getActivatePromoError = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.promo && state.user.profile.promo.error
    ? state.user.profile.promo.error : null,
  error => error
)
